import {
    Box,
    Heading,
    Icon,
    Icons,
    Text,
    ThemeColorVariable,
    ThemeFontSizeVariable,
    ThemeIconSizeVariable,
    ThemeSpaceVariable,
} from "@caspeco/casper-ui-library";

interface IEmptyState {
    icon?: Icons;
    header: string;
    description: string;
    pt?: ThemeSpaceVariable;
}

/**
 * Presents an icon and text that indicates that there is no data to show.
 */
const EmptyState = ({
    icon = Icons.CircleInfo,
    header,
    description,
    pt = ThemeSpaceVariable.None,
}: IEmptyState) => {
    return (
        <Box
            justifyContent={"center"}
            alignItems="center"
            textAlign="center"
            p={ThemeSpaceVariable.Medium}
            pt={pt}
        >
            <Icon
                icon={icon}
                size={ThemeIconSizeVariable.X3Large}
                color={ThemeColorVariable.OnBackgroundBorder}
                mb={ThemeSpaceVariable.Medium}
            />
            <Heading
                as="h3"
                fontWeight="500"
                fontSize={{
                    sm: ThemeFontSizeVariable.Large,
                    lg: ThemeFontSizeVariable.XLarge,
                }}
            >
                {header}
            </Heading>
            <Text
                fontSize={{
                    sm: ThemeFontSizeVariable.Medium,
                    lg: ThemeFontSizeVariable.Large,
                }}
            >
                {description}
            </Text>
        </Box>
    );
};

export default EmptyState;
